import trackEvent from "@analytics/utils/trackEvent";

import { PopupActions } from "@store/popupStore";

const FlaggingAnalyticsService = {
  dataIssueFlagged: (id: string, issue: string, feedback: string, workflow: string, supressAlert: boolean = false) => {
    if (!supressAlert) {
      PopupActions.openAlert({
        duration: 4000,
        message: "Thanks for your feedback! We will review and update the data as soon as possible.",
        severity: "success",
      });
    }
    trackEvent("Data Issue Flagged", { feedback, id, issue, workflow });
  },
};

export default FlaggingAnalyticsService;
